import { useState } from 'react';

const IconArrow = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);

export default function ModalParametroInicio({ desafio, onConfirmar, onCancelar }) {
  const [selecionado, setSelecionado] = useState(null);
  const opcoes = desafio?.parametro_opcoes_array || [];

  return (
    <div className="modal-parametro-backdrop" onClick={e => e.target === e.currentTarget && onCancelar()}>
      <div className="modal-parametro-card">
        <div className="modal-parametro-header">
          <p className="modal-parametro-supra">Antes de começar</p>
          <h3 className="modal-parametro-titulo">
            {desafio?.parametro_pergunta_antes || 'Como você está agora?'}
          </h3>
          {desafio?.parametro_label && (
            <p className="modal-parametro-label">{desafio.parametro_label}</p>
          )}
        </div>

        <div className="modal-parametro-opcoes">
          {opcoes.map((opcao, i) => (
            <button
              key={i}
              className={`modal-parametro-opcao ${selecionado === opcao ? 'selecionado' : ''}`}
              onClick={() => setSelecionado(opcao)}
            >
              {opcao}
            </button>
          ))}
        </div>

        <div className="modal-parametro-acoes">
          <button
            className="btn btn-primary"
            style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}
            onClick={() => selecionado && onConfirmar(selecionado)}
            disabled={!selecionado}
          >
            Começar desafio <IconArrow />
          </button>
          <button className="btn btn-ghost" style={{ width: '100%' }} onClick={onCancelar}>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}
